import { gql } from '@apollo/client';

export const QUOTE_EQUIPMENT_TRADE_INS_FRAGMENT = gql`
  fragment QuoteEquipmentTradeInsFields on QuoteEquipmentTradeInsResponse {
    vin
    externalId
    equipmentId
    stockNumber
    tradeInDetails {
      tradeValue
      tradeAmountOwed
    }
    attributes {
      key
      value
      description
    }
  }
`;
